import ErrorBoundary from "components/error-boundary";
import PartnerSubmittalLog from "./feature-model-pages/partner-submittal-log";

function PartnerSubmittalLogLanding() {
  return (
    <ErrorBoundary>
      <PartnerSubmittalLog />
    </ErrorBoundary>
  );
}

export default PartnerSubmittalLogLanding;
